import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import TitleBar from "../../components/common-components/TitleBar";
import brexLogo from "../../assets/Images/brex.svg";
import mercuryLogo from "../../assets/Images/mercury.svg";
import theLogo from "../../assets/Images/wise.svg";
import paypal from "../../assets/Images/paypall.svg";
import relay from "../../assets/Images/relay.svg";
import stripe from "../../assets/Images/stripe1.svg";
import BppCard from "../../components/bpp/BppCard";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import { useDispatch } from "react-redux";
import { getMerecryDetailUrl } from "../../stores/bpp";

const Bpp = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingType, setLoadingType] = useState<string | null>(null);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // 1.5 seconds loading time

    return () => clearTimeout(timer);
  }, []);

  const handleBrexClick = async (type: string) => {
    if (type === "brex") {
      window.open("https://www.brex.com/signup", "_blank");
    } else if (type === "wise") {
      window.open("https://wise.com/register", "_blank");
    } else if (type === "paypal") {
      window.open(
        "https://www.paypal.com/in/webapps/mpp/account-selection",
        "_blank",
      );
    } else if (type === "stripe") {
      window.open("https://dashboard.stripe.com/register", "_blank");
    } else if (type === "relay") {
      window.open("https://app.relayfi.com/register", "_blank");
    } else if (type === "mercury") {
      try {
        setLoadingType("mercury"); // 🔥 start loader
        const res = await dispatch<any>(getMerecryDetailUrl());

        const url = res?.payload?.data?.signup_url;

        if (url) {
          window.open(url, "_blank");
        } else {
          console.warn("Signup URL not found");
          return;
        }
      } catch (error) {
        console.error("Error fetching Mercury URL:", error);
      } finally {
        setLoadingType(null); // 🔥 stop loader
      }
    }
  };

  const handleKnowMoreClick = (type: string) => {
    if (type === "brex") {
      window.open("https://www.brex.com/", "_blank");
    } else if (type === "wise") {
      window.open("https://wise.com/", "_blank");
    }
  };

  if (isLoading) {
    return (
      <>
        {/* <TitleBar title="Bank and Payment Providers" /> */}
        <ListLoadingNew />
      </>
    );
  }

  return (
    <>
      <TitleBar title="Bank and Payment Providers" />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <BppCard
          img={brexLogo}
          description="Get a business account, credit card, and spend management software—in one refreshingly easy solution. No fees or minimums. Brex integrates with QuickBooks, Xero, NetSuite, Gusto, Slack, and more seamlessly."
          handleClick={() => handleBrexClick("brex")}
          title="Setup Brex"
          handleKnowMoreClick={() => handleKnowMoreClick("brex")}
        />
        <BppCard
          img={theLogo}
          description="The no-hassle international business account.
          Business banking without the high rates, hidden charges,
           and monthly fees. Pay employees, get paid and manage your cash flow overseas — in one place."
          handleClick={() => handleBrexClick("wise")}
          title="Setup Wise"
          handleKnowMoreClick={() => handleKnowMoreClick("wise")}
        />

        <BppCard
          img={mercuryLogo}
          description="Mercury is 
         building banking for startups. We want to power the next generation of companies
         that will shape American industry. Some of Silicon Valley's sharpest minds are funding us to b
         e the bedrock of our ecosystem."
          handleClick={() => handleBrexClick("mercury")}
          title="Setup Mercury"
          loadingType={loadingType}
          isKnow={true}
        />
        <BppCard
          img={stripe}
          description="Stripe is a secure and widely used online payment platform that allows businesses to accept credit and debit card payments globally. It provides a seamless checkout experience and supports multiple currencies. With Stripe, we can handle transactions, manage payouts, and even automate fund transfers between buyers and sellers through features like Connect and Payment Intents."
          handleClick={() => handleBrexClick("stripe")}
          title=" Setup Stripe"
          isKnow={true}
        />
        <BppCard
          img={paypal}
          description="PayPal is a trusted digital payment solution that enables users to send and receive money quickly using their PayPal balance, linked bank accounts, or cards. It offers easy integration for both one-time and recurring payments. PayPal’s buyer and seller protection policies make it a preferred choice for secure online transactions. "
          handleClick={() => handleBrexClick("paypal")}
          title="Setup PayPal"
          isKnow={true}
        />
        <BppCard
          img={relay}
          description="RelayFi is a modern banking platform designed for startups and businesses. It allows us to create and manage business bank accounts with features like multi-user access, automated transfers, and integrated expense tracking. RelayFi supports ACH and wire transfers, making it efficient for managing company finances, payroll, and vendor payments directly from the platform."
          handleClick={() => handleBrexClick("relay")}
          title="Setup RelayFi"
          isKnow={true}
        />
      </Box>
    </>
  );
};

export default Bpp;
